/* Maison Ella — acertos do carrinho: faixa de benefícios e Continue shopping. */
(function () {
  'use strict';

  /* Os três benefícios entram numa linha só, na gaveta e na página. */
  function benefits() {
    var blocks = Array.prototype.slice.call(document.querySelectorAll('.cart-block'))
      .filter(function (el) { return el.querySelector('.block__icon__container') && !el.closest('.pdpb-benefits'); });
    if (blocks.length < 2) return;

    var groups = [];
    blocks.forEach(function (el) {
      var last = groups[groups.length - 1];
      if (last && last[last.length - 1].nextElementSibling === el) last.push(el);
      else groups.push([el]);
    });

    groups.forEach(function (g) {
      if (g.length < 2) return;
      var row = document.createElement('div');
      row.className = 'pdpb-benefits';
      g[0].parentNode.insertBefore(row, g[0]);
      g.forEach(function (el) { row.appendChild(el); });
    });
  }


  /* "Continue shopping" no topo da gaveta, ao lado do título. */
  function keepShopping() {
    document.querySelectorAll('.drawer__head').forEach(function (head) {
      if (head.dataset.keepReady) return;
      head.dataset.keepReady = '1';
      var close = head.querySelector('[data-cart-drawer-close], .drawer__close, button');
      var link = document.createElement('button');
      link.type = 'button';
      link.className = 'pdpb-keep-shopping';
      link.textContent = 'Continue shopping';
      link.addEventListener('click', function () {
        if (close) close.click();
        else document.dispatchEvent(new CustomEvent('theme:cart:close'));
      });
      if (close) head.insertBefore(link, close);
      else head.appendChild(link);
    });
  }



  /* Na página do carrinho: preço à direita, com o seletor e a lixeira por baixo.
     O nome fica à esquerda, em no máximo duas linhas. */
  function itemLayout() {
    if (!document.body.classList.contains('template-cart')) return;
    document.querySelectorAll('.cart__item').forEach(function (item) {
      if (item.dataset.pdpbLayout) return;
      var right = item.querySelector('.cart__item__content__right');
      var qty = item.querySelector('.cart__quantity-wrapper');
      var remove = item.querySelector('.cart__item__remove');
      if (!right || !qty) return;
      item.dataset.pdpbLayout = '1';
      right.appendChild(qty);
      if (remove) right.appendChild(remove);
      item.classList.add('pdpb-item');
    });
  }


  /* "Continue shopping" da página vira link, para não competir com o checkout */
  function keepShoppingPage() {
    if (!document.body.classList.contains('template-cart')) return;
    Array.prototype.slice.call(document.querySelectorAll('a.btn')).forEach(function (a) {
      if (/continue shopping/i.test(a.textContent) && !a.classList.contains('pdpb-keep-link')) {
        a.classList.add('pdpb-keep-link');
      }
    });
  }


  /* O selo Rewards fica por cima do CHECK OUT. O app escreve o estilo no
     próprio elemento, por isso esconder pelo CSS não pega: é pelo JS. */
  function hideRewards() {
    if (!document.body.classList.contains('template-cart')) return;
    var el = document.getElementById('mcb-launcher-widget-root');
    if (!el) return;
    el.style.setProperty('display', 'none', 'important');
  }


  /* Barra flutuante de checkout.
   *
   * A coluna do resumo passou dos 1600px (benefícios, i=Change, Rewards, Gift
   * options, Pairs well with). O `position: sticky` que ela tem deixou de valer
   * porque sticky só segura elementos que cabem no ecrã — com o dobro da altura
   * da janela, o CHECK OUT fica sempre abaixo da dobra.
   *
   * A barra aparece só quando o botão verdadeiro está fora de vista e desaparece
   * quando ele entra, para nunca haver dois botões visíveis ao mesmo tempo.
   * Clicar nela aciona o botão real, para o formulário do tema levar descontos,
   * notas e atributos do carrinho. */
  function checkoutBar() {
    if (!document.body.classList.contains('template-cart')) return;

    var real = document.querySelector('[name="checkout"]');
    var total = document.querySelector('.cart__total__price');
    var bar = document.getElementById('pdpb-cobar');

    if (!real || !total) {
      if (bar) bar.remove();
      return;
    }

    if (!bar) {
      bar = document.createElement('div');
      bar.id = 'pdpb-cobar';
      bar.className = 'pdpb-cobar';
      bar.innerHTML =
        '<div class="pdpb-cobar__inner">' +
          '<div class="pdpb-cobar__sum">' +
            '<span class="pdpb-cobar__label">Subtotal</span>' +
            '<span class="pdpb-cobar__price" data-cobar-price></span>' +
          '</div>' +
          '<button type="button" class="pdpb-cobar__btn" data-cobar-go>CHECK OUT</button>' +
        '</div>';
      document.body.appendChild(bar);
      bar.querySelector('[data-cobar-go]').addEventListener('click', function () {
        var target = document.querySelector('[name="checkout"]');
        if (target) target.click();
      });
    }

    bar.querySelector('[data-cobar-price]').textContent = total.textContent.trim();

    /* o tema redesenha o rodapé a cada alteração: reatamos o observer ao
       botão novo, senão a barra fica presa no estado anterior */
    if (real.dataset.cobarWatched) return;
    real.dataset.cobarWatched = '1';

    if (!('IntersectionObserver' in window)) {
      bar.classList.add('is-on');
      return;
    }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('is-on', !e.isIntersecting);
      });
    }, { rootMargin: '0px 0px -20px 0px' }).observe(real);
  }

  function run() { benefits(); keepShopping(); keepShoppingPage(); itemLayout(); hideRewards(); checkoutBar(); }
  function boot() { run(); [500, 1500, 3000, 6000].forEach(function (t) { window.setTimeout(run, t); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('theme:cart:change', boot);
  document.addEventListener('theme:cart:update', boot);
})();
